<template>
	<c-dialog ref="dialog" width="670px" mask-close :button="false">
		<div class="scan-input flex-center-cross">
			<c-input ref="codeInput" v-model="scanCode" class="flex-grow" placeholder="请扫描或输入背贴码" style="width: auto; height: 50px; padding: 0 5px; border-radius: 6px 0 0 6px;" @keyup.enter.native="scanHandle">
				<template #appendIcon><i class="tf-scan" style="font-size: 20px; color: #bbb;"></i></template>
			</c-input>
			<c-button color="main" style="width: 60px; height: 50px; padding: 0; border-radius: 0 6px 6px 0; font-size: 24px;" @click="scanHandle"><i class="tf-search"></i></c-button>
		</div>
	</c-dialog>
</template>

<script>
export default {
	name: 'qualityReportScan',

	props: {
		// 报告类型（1：B端，2：C端）
		reportType: {
			type: [String, Number],
			default: 1
		}
	},

	data() {
		return {
			scanCode: ''
		}
	},

	methods: {
		/*********打开弹框**********/
		open() {
			this.scanCode = '';
			this.$refs.dialog.open({
				title: this.reportType == 1 ? '添加B端质检报告' : '添加C端质检报告'
			});
			this.focusInput();
		},

		/*********聚焦输入框**********/
		focusInput() {
			this.$nextTick(() => {
				var input = this.$refs.codeInput && this.$refs.codeInput.$el.querySelector('input');
				if (input) input.focus();
			});
		},

		/*********扫码查询**********/
		scanHandle() {
			var code = this.scanCode.trim();
			if (!code) {
				this.$message({message: '请输入背贴码', type: 'warn'});
				return;
			}
			this.request({
				url: '/quality/product/queryByCode',
				data: {
					produce_unique_code: code
				},
				loading: true,
				success: (data) => {
					this.$refs.dialog.close();
					this.$emit('resolve', data);
				},
				fail: (msg) => {
					this.$message({message: msg, type: 'warn'});
					this.scanCode = '';
					this.focusInput();
				}
			});
		}
	}
}
</script>

<style lang="stylus" scoped>
	.scan-input
		padding 100px 50px 170px
</style>
